"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtocolInitialMessageSummary = void 0;
var ProtocolInitialMessageSummary;
(function (ProtocolInitialMessageSummary) {
    ProtocolInitialMessageSummary["Success"] = "Success";
    ProtocolInitialMessageSummary["Error"] = "Error";
    ProtocolInitialMessageSummary["Pending"] = "Pending";
})(ProtocolInitialMessageSummary || (exports.ProtocolInitialMessageSummary = ProtocolInitialMessageSummary = {}));
